<template>
  <div>
    <v-divider class="mt-4 mb-4" />
    
    <div class="d-flex justify-end">
      <v-btn
        v-if="showCancel"
        text
        @click="$emit('cancel')"
      >
        {{ $t('common.cancel') }}
      </v-btn>
      <v-btn
        v-if="showBack"
        text
        @click="$emit('back')"
      >
        {{ $t('common.back') }}
      </v-btn>
      <v-btn
        :color="nextColor"
        class="ml-2"
        :disabled="nextDisabled"
        @click="$emit('next')"
      >
        {{ nextText || $t('common.next') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepperNavigation',
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    nextDisabled: {
      type: Boolean,
      default: false
    },
    nextText: {
      type: String,
      default: null
    },
    nextColor: {
      type: String,
      default: 'primary'
    }
  },
  emits: ['back', 'next', 'cancel']
}
</script>